import dynamic from 'next/dynamic';
import EditAgentModal from './EditAgentModal/EditAgentModal';

const AgentGrid = dynamic(() => import('./AgentGrid/AgentGrid'));
const AddAgentModal = dynamic(() => import('./AddAgentModal'));
const AgentFilter = dynamic(() => import('./AgentFilter/AgentFilter'));

export { AgentGrid, AddAgentModal, EditAgentModal, AgentFilter };
